import { render, staticRenderFns } from "./TopicContent.vue?vue&type=template&id=1b4d0712&"
import script from "./TopicContent.vue?vue&type=script&lang=js&"
export * from "./TopicContent.vue?vue&type=script&lang=js&"
import style0 from "./TopicContent.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports